import ListActions from "modules/list/actions";
import ModalService from "services/modal";
import {
  policiesFetcher,
  policiesFiltersFetcher,
} from "state/clusterdefinitions/services/policies";
import { PolicySchema } from "utils/schemas";

export const maintenancePolicySelectionActions = new ListActions({
  hasPagination: true,
  persistFilters: true,
  schema: [PolicySchema],
  defaultQuery: {
    limit: 25,
  },
  initialQuery: () => {
    return {
      limit: 25,
      policyType: ["maintenance"],
    };
  },
  dataFetcher: policiesFetcher,
  filtersFetcher: policiesFiltersFetcher,
  filtersConfig: {
    data: {
      policyName: {
        componentType: "search",
        search: true,
        placeholder: "Filter by policy name",
        operator: "contains",
      },
      tags: {
        locked: true,
        componentType: "dropdown",
      },
    },
    order: ["policyType", "tags"],
    showExtendedFilters: false,
  },
});

export const maintenancePolicySelectionService = new ModalService(
  "maintenancePolicySelectionService"
);
